module.exports = __webpack_public_path__ + "img/6 (2).d1b534d0.jpg";